<template>
    <div>
        <header>
            <div class="header">
                <div class="container">
                    <div class="row">
                        <div class="col-12 col-md-4 col-xl-6 d-flex align-items-center">
                            <router-link :to="{name:'Home'}">
                                <img class="logo-sollicita" :src="logo" />
                            </router-link>
                        </div>
                        <div class="col-12 col-md-8 col-xl-6 mt-3 mt-sm-0">
                            <template v-if="!user">
                                <div class="d-flex justify-content-between">
                                    <div class="d-flex flex-column w-50">
                                        <span class="txt-p txt-white txt-w-5">TENHA ACESSO AOS CURSOS!</span>
                                        <p class="txt-p txt-size-14 txt-grey-3 txt-w-4">Crie sua conta e tenha acesso a cursos gratuitos e a loja de cursos.</p>
                                        <a class="btn btn-yellow w-100 p-0" :href="linkPlanos" target="_blank">Crie sua conta</a>
                                        <!--<button class="btn btn-yellow w-100 p-0" @click="showModalCadastro= !showModalCadastro">Crie sua conta</button>-->
                                    </div>
                                    <div class="divisor mx-3 d-none d-sm-block"></div>
                                    <div class="">
                                        <div class="d-flex justify-content-between mb-1">
                                            <div>
                                                <a class="txt-h-6 txt-size-12 txt-white c-pointer" href="javascript:void(0)" @click="showModalEsqueciSenha = !showModalEsqueciSenha">Esqueci a senha</a>
                                            </div>
                                            <div class="divisor"></div>
                                            <div>
                                                <a class="txt-h-6 txt-size-12 txt-white c-pointer" href="javascript:void(0)" @click="autoatendimento">Autoatendimento</a>
                                            </div>

                                        </div>
                                        <form>
                                            <div class="mb-1">
                                                <input class="w-100 input-text" type="text" placeholder="Usuário" v-model="userLogin.login" required />
                                            </div>
                                            <div class="d-flex">
                                                <input class="input-text me-1" type="password" name="senha" value="" placeholder="Senha" v-model="userLogin.password" v-on:keyup.enter="entrar" required />
                                                <button class="btn btn-yellow w-100 p-0 px-3" type="button" @click="entrar">
                                                    Entrar
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="d-flex" style=" position: relative; width: 100%; height: 100%; display: flex; justify-content: end; align-items: center;">
                                    <div :class="'box-dados-usuario ' + (flDadosUsuario ?'active':'' )">
                                        <div class="box-dados-usuario-titulo" @click="flDadosUsuario = !flDadosUsuario">
                                            <template v-if="user.usuario">
                                                <!--<img :src="user.usuario.urlImgFoto" v-if="user.usuario.urlImgFoto != null" />
                                            <ImgDefault :nome="user.usuario.nmUsuario" :size="1" :borda="true" v-else></ImgDefault>-->
                                                <ImgDefault :nome="user.usuario.nmUsuario" :size="1" :borda="true"></ImgDefault>
                                            </template>


                                            <span class="ms-3 txt-p txt-size-20" v-if="user.usuario != null">Olá, <b>{{primeiroNome}}</b></span>
                                            <span class="ms-3 txt-p c-pointer txt-size-20" data-bs-toggle="dropdown" aria-expanded="false"><i class="fas fa-caret-down"></i></span>
                                        </div>


                                        <div class="box-dados-usuario-conteudo">
                                            <p class="txt-p txt-blue-1 txt-w-5 c-pointer mb-1" @click="showModalDados = !showModalDados"><i class="fas fa-user me-2"></i> Meus dados</p>
                                            <p class="txt-p txt-blue-1 txt-w-5 c-pointer mb-1" @click="showModalSenha = !showModalSenha"><i class="fas fa-key me-2"></i> Mudar senha</p>
                                            <p class="txt-p txt-blue-1 txt-w-5 c-pointer mb-2" @click="sair"><i class="fas fa-sign-out-alt me-2"></i> Sair</p>

                                        </div>

                                    </div>
                                </div>
                            </template>

                        </div>
                    </div>

                </div>
            </div>

            <div class="navegacao">
                <div class="container">
                    <div class="row">
                        <div class="col-12 col-md-12 d-flex align-items-center justify-content-center">
                            <div class="d-flex flex-wrap">
                                <template v-if="user">
                                    <template v-for="(item) in navegacaoLogado">
                                        <router-link :key="item.id"
                                                     :to="{name:item.route}" :class="(subIsActive(item) ? 'txt-h-6 txt-size-14 me-4 navegacao-active py-3 c-pointer txt-white':'txt-h-6 txt-size-14 txt-white me-4 py-3 c-pointer')">
                                            {{item.nome}}
                                        </router-link>
                                    </template>
                                </template>
                                <template v-else>
                                    <template v-for="(item) in navegacao">
                                        <router-link :key="item.id"
                                                     :to="{name:item.route}" :class="(subIsActive(item) ? 'txt-h-6 txt-size-14 me-4 navegacao-active py-3 c-pointer txt-white':'txt-h-6 txt-size-14 txt-white me-4 py-3 c-pointer')">
                                            {{item.nome}}
                                        </router-link>
                                    </template>
                                </template>

                                <router-link :to="{name:'Carrinho'}" :class="(subIsActive({route:'Carrinho'}) ? 'carrinho txt-h-6 txt-size-18 me-4 navegacao-active c-pointer txt-white':' carrinho txt-h-6 txt-size-18 txt-white me-4 c-pointer')">
                                    <i class="fas fa-shopping-cart"></i>
                                    <span class="badge badge-qtdcarrinho d-block" v-if="qtdCarrinho">{{qtdCarrinho}}</span>
                                </router-link>

                                <div class="divisor-menu me-4"></div>

                                <p class="txt-h-6 txt-size-14 txt-cores-1 me-4 py-3 c-pointer mb-0" @click="portal">PORTAL SOLLICITA<i class="fas fa-external-link-alt ms-1"></i></p>
                                <p class="txt-h-6 txt-size-14 txt-cores-1 me-4 py-3 c-pointer mb-0" @click="ferramentas">FERRAMENTAS<i class="fas fa-external-link-alt ms-1"></i></p>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </header>

        <MudarSenha :showModal="showModalSenha"></MudarSenha>
        <MeusDados :showModal="showModalDados"></MeusDados>
        <EsqueciMinhaSenha :showModal="showModalEsqueciSenha"></EsqueciMinhaSenha>
        <ModalCadastro :showModal="showModalCadastro"></ModalCadastro>

    </div>
</template>

<script>
    import logo from '@/assets/img/Logo.png';
    import ImgDefault from '@/components/ImgDefault'
    import MudarSenha from '@/components/MudarSenha'
    import MeusDados from '@/components/MeusDados'
    import EsqueciMinhaSenha from '@/components/EsqueciMinhaSenha'
    import ModalCadastro from '@/components/ModalCadastro'
        
    import { urlApi, avisoErro, linkPortal, idModulo, cdProduto, linkFerramentas, linkPlanos } from '@/config/global'
    import axios from 'axios'

    export default {
        name: 'Header',
        components: { ImgDefault, EsqueciMinhaSenha, MudarSenha, MeusDados, ModalCadastro },
        computed: {
            user() {
                return this.$store.state.user
            },

            primeiroNome() {
                if (this.user && this.user.usuario) {
                    if (this.user.usuario.nmUsuario) {
                        return this.user.usuario.nmUsuario.split(" ")[0]
                    } else {
                        return "";
                    }
                } else {
                    return "";
                }
                
            },

            qtdCarrinho() {
                if (this.$store.state.carrinho) {
                    return this.$store.state.carrinho.length;
                } else {
                    return 0;
                }
            },
        },
        data: function () {
            return {
                logo,
                linkPlanos: linkPlanos,
                userLogin: {
                    login: "",
                    password: "",
                    idModulo: idModulo,
                    
                },
                cdProduto: cdProduto,
                navegacao: [
                    { id: 1, nome: "HOME", route: "Home"},
                    //{ id: 2, nome: "O QUE É O CAPACITAÇÃO?", route: "Sobre"},
                    { id: 3, nome: "ESTANTE DE CURSOS", route: "Estante" },
                    { id: 4, nome: "PROFESSORES", route: "Professores" },
                ],

                navegacaoLogado: [
                    { id: 1, nome: "MEUS CURSOS", route: "MeusCursos" },
                    { id: 2, nome: "ESTANTE DE CURSOS", route: "Estante" },
                    { id: 3, nome: "PROFESSORES", route: "Professores" },
                ],

                flDadosUsuario: false,
                showModalDados: false,
                showModalSenha: false,
                showModalEsqueciSenha: false,
                showModalCadastro: false,

                flgModalTransmissao: false,
            }
        },
        methods: {

            portal() {
                var url = '';
                if (this.user) {
                     url = linkPortal + 'AutenticacaoAutomatica?token=' + this.user.accessToken + '&refreshTokenWeb=' + this.user.refreshTokenWeb;
                } else {
                    url = linkPortal;
                }
                
                window.location.href = encodeURI(url);
            },

            ferramentas() {
                var url = '';
                if (this.user) {
                    url = linkFerramentas + 'AutenticacaoAutomatica?token=' + this.user.accessToken + '&refreshTokenWeb=' + this.user.refreshTokenWeb;
                } else {
                    url = linkFerramentas;
                }
                window.location.href = encodeURI(url);
            },

            subIsActive(input) {
                
                let name = this.$route.name.split('-')[0];
                
                return name.toLowerCase() == input.route.toLowerCase();
                
            },

            entrar(event) {
                event.preventDefault();
                if (this.checkForm()) { 
                    let $this = this;
                    axios.post(`${urlApi}/Auth/signin`, this.userLogin)
                        .then(res => {
                            if (res.data.token.authenticated) {
                                res.data.token.usuario = res.data.usuario;
                                $this.$store.commit('setUser', res.data.token);
                                $this.$router.push({ name: 'MeusCursos' });
                            } else {
                                avisoErro("Erro ao realizar login.");
                            }
                        })
                        .catch(err => {
                            if (err.response.data.msg) {
                                var msg = err.response.data.msg + '. ' + err.response.data.errors[0];
                                avisoErro(msg);
                            } else {
                                avisoErro("Login e/ou senha inválidos.");
                            }
                        })
                }

                return false;
            },


            checkForm() {
                var form = document.querySelector('form')
                if (!form.checkValidity()) {
                    var tmpSubmit = document.createElement('button')
                    form.appendChild(tmpSubmit)
                    tmpSubmit.click()
                    form.removeChild(tmpSubmit)

                    return false;
                }

                return true;
            },

            autoatendimento() {
                document.getElementById('blip-chat-icon').click();
            },

            sair() {
                let $this = this;
                axios.get(`${urlApi}/Auth/revoke`)
                    .then(function () {
                        $this.$store.commit('setUser', null)
                        location.reload();
                    })
                    .catch(res => {
                        if (res.response.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                    });
            },

            
        },
        mounted: function () {
           
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    
    .header {
        background: linear-gradient(98.19deg, #0C1C25 1.55%, #163142 54.88%, #0C1C25 100%);
        padding: 20px 0;
    }

    .logo-sollicita{
        max-height: 91px;
        
    }

    .navegacao {
        background: linear-gradient(98.19deg, #0C1C25 1.55%, #0c1c25 54.88%, #0C1C25 100%);

        .divisor-menu {
            border-left: 2px solid #173243;
            margin: 10px 0;
        }
    }

    .carrinho {
        padding-top: 13px;
        position: relative;

        .badge-qtdcarrinho {
            position: absolute;
            right: -10px;
            top: 0px;
            color: #212529;
            background-color: #ffc107;
            font-size: 10px;
            padding: 3px 4px;
        }
    }

    .navegacao-active {
        border-bottom: 5px solid #FFF;
    }

    .divisor {
        border: 1px solid #FFFFFF;
    }

    .box-dados-usuario {
        padding: 10px;
        color: #FFF;
        z-index: 999;

        .box-dados-usuario-conteudo {
            display: none;
        }

        .box-dados-usuario-titulo {
            cursor: pointer;
            display: flex;
            align-items: center;

            img {
                width: 45px;
                height: 45px;
                border-radius: 50%;
            }
        }
    }

    .box-dados-usuario.active {
        position: absolute;
        top: 15%;
        background-color: #FFF;
        box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
        border-radius: 10px;
        color: #071B28;

        .box-dados-usuario-conteudo {
            display: block;
            margin-top: 15px;

            p:hover {
                border-radius: 5px;
                background-color: color('grey','3');
            }
        }
    }
</style>

